var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMtLogoStackedColourTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 369.4 362.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-5{opacity:.97;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 299.89,
    y1: 52.79,
    x2: 76.21,
    y2: 223.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c50c88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 155.76,
    y1: 96.35,
    x2: 143.54,
    y2: 189.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 227.09,
    y1: 133.33,
    x2: 239.46,
    y2: 226.82,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m184.73,281.61c-77.64.02-140.82-63.14-140.83-140.78C43.88,63.19,107.03.02,184.67,0c77.64-.02,140.82,63.14,140.83,140.78.02,77.64-63.14,140.82-140.78,140.83Zm-.05-270.57c-71.55.01-129.75,58.24-129.74,129.79.01,71.55,58.24,129.75,129.79,129.74s129.75-58.24,129.74-129.79S256.23,11.03,184.67,11.04Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "201.29 139.58 135.55 73.87 107.51 73.87 173.25 139.58 106.98 205.88 107.5 206.4 134.5 206.39 201.29 139.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "251.26 138.35 184.99 204.65 185.5 205.17 212.51 205.16 279.29 138.35 213.56 72.64 185.52 72.64 251.26 138.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.2,334.18h17.97v6.62h-10.2v3.88h8.64v6.24h-8.64v4.19h10.66v6.62h-18.42v-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.88,362.15c-9.13,0-15.3-6.09-15.3-14.12s6.47-14.27,15.42-14.27c2.82,0,5.52.61,7.65,1.71v7.5c-2.05-1.26-4.76-2.25-7.42-2.25-4.65,0-7.8,3.01-7.8,7.19s2.97,7.27,7.99,7.27c2.67,0,5.37-.95,7.61-2.36v7.46c-2.32,1.26-5.36,1.86-8.14,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.35,334.18h7.84v9.93h9.82v-9.93h7.84v27.56h-7.84v-11h-9.82v11h-7.84v-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m277.21,334.18h7.35l7.31,9.97c1.52,2.06,2.85,3.92,4.23,5.9h.07c-.04-2.36-.07-4.72-.07-7.04v-8.83h7.53v27.56h-7.35l-7.31-9.97c-1.52-2.06-2.85-3.92-4.22-5.9h-.08c.04,2.36.08,4.72.08,7.04v8.83h-7.54v-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m307.98,334.18h7.84v27.56h-7.84v-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m327.78,334.18v14.96c0,1.98.42,3.42,1.3,4.41.87.95,2.13,1.56,3.77,1.56s2.89-.61,3.77-1.56c.87-.95,1.29-2.4,1.29-4.41v-14.96h7.54v15.64c0,3.27-.88,6.39-3.05,8.68-2.17,2.28-5.71,3.65-9.7,3.65s-7.54-1.37-9.71-3.65c-2.17-2.28-3.05-5.48-3.05-8.68v-15.64h7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m358.63,355.65c1.75,0,2.82-.61,2.82-1.94,0-1.03-.68-1.52-2.32-2.05-1.64-.53-5.1-1.22-7.23-2.63-2.13-1.41-3.24-3.39-3.24-6.28,0-5.63,4.07-8.98,10.31-8.98,2.82,0,6.4.72,8.98,2.02v7.08c-3.31-1.83-6.85-2.59-8.72-2.59-1.67,0-2.63.61-2.63,1.79,0,1.03.72,1.52,2.32,2.02s5.02,1.22,7.19,2.59c2.17,1.37,3.28,3.58,3.28,6.4,0,5.78-4.26,9.1-10.7,9.1-2.93,0-6.7-.68-9.52-2.09v-7.42c3.5,2.17,7.54,3.01,9.44,3.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.2 340.8 184.53 337.47 181.24 334.18 172.44 334.18 172.44 340.8 181.2 340.8 181.2 340.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "189.04 340.81 189.04 340.81 189.04 340.8 189.04 340.8 192.38 337.47 189.08 334.18 183.16 334.18 186.45 337.47 183.11 340.81 181.2 340.81 181.2 361.74 189.04 361.74 189.04 340.81 189.04 340.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.01 334.18 194.3 337.47 190.97 340.8 197.79 340.8 197.79 334.18 191.01 334.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,334.18h7.54l7.12,10.05,7.08-10.05h7.46v27.56h-7.84v-8.98c0-2.17.04-4.61.08-6.51h-.08c-1.14,1.75-2.4,3.58-3.62,5.29l-3.27,4.64-3.31-4.64c-1.26-1.75-2.47-3.54-3.62-5.29h-.08c.04,1.9.08,4.34.08,6.51v8.98H0v-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.53,334.18h7.84v27.56h-7.84v-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.77,355.65c1.75,0,2.82-.61,2.82-1.94,0-1.03-.69-1.52-2.32-2.05-1.64-.53-5.1-1.22-7.23-2.63-2.13-1.41-3.23-3.39-3.23-6.28,0-5.63,4.07-8.98,10.31-8.98,2.82,0,6.39.72,8.98,2.02v7.08c-3.31-1.83-6.85-2.59-8.72-2.59-1.67,0-2.63.61-2.63,1.79,0,1.03.72,1.52,2.32,2.02,1.6.5,5.02,1.22,7.19,2.59,2.17,1.37,3.27,3.58,3.27,6.39,0,5.79-4.26,9.1-10.7,9.1-2.93,0-6.7-.69-9.52-2.09v-7.42c3.5,2.17,7.54,3.01,9.44,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m77.65,355.65c1.75,0,2.82-.61,2.82-1.94,0-1.03-.69-1.52-2.32-2.05-1.64-.53-5.1-1.22-7.23-2.63-2.13-1.41-3.23-3.39-3.23-6.28,0-5.63,4.07-8.98,10.31-8.98,2.82,0,6.39.72,8.98,2.02v7.08c-3.31-1.83-6.85-2.59-8.72-2.59-1.67,0-2.63.61-2.63,1.79,0,1.03.72,1.52,2.32,2.02,1.6.5,5.02,1.22,7.19,2.59,2.17,1.37,3.27,3.58,3.27,6.39,0,5.79-4.26,9.1-10.7,9.1-2.93,0-6.7-.69-9.52-2.09v-7.42c3.5,2.17,7.54,3.01,9.44,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.46,334.18h7.84v27.56h-7.84v-27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.69,347.96c0-8.03,6.32-14.2,14.73-14.2s14.73,6.17,14.73,14.2-6.28,14.2-14.73,14.2-14.73-6.17-14.73-14.2Zm21.62,0c0-4.11-2.78-7.27-6.89-7.27s-6.89,3.16-6.89,7.27,2.78,7.27,6.89,7.27,6.89-3.16,6.89-7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m135.54,334.18h7.35l7.31,9.97c1.52,2.05,2.85,3.92,4.22,5.9h.08c-.04-2.36-.08-4.72-.08-7.04v-8.83h7.54v27.56h-7.35l-7.31-9.97c-1.52-2.05-2.85-3.92-4.22-5.9h-.08c.04,2.36.08,4.72.08,7.04v8.83h-7.54v-27.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtLogoStackedColourTransparent);
export default __webpack_public_path__ + "static/media/MT-logo-stacked-colour-transparent.ee053dc3005c7368514db10d34978359.svg";
export { ForwardRef as ReactComponent };